import React from 'react';
import { Skeleton } from 'gatorcomponents';
import * as Styles from '../AudioRecording.styles';

const TranscriptionSkeleton = () => (
  <Styles.SkeletonWrapper>
    <Skeleton width="100%" height="16px" />
    <Skeleton width="100%" height="16px" />
    <Skeleton width="40%" height="16px" />
  </Styles.SkeletonWrapper>
);

export default TranscriptionSkeleton;
